import { makeStyles } from '@material-ui/styles';
import type { Theme } from '@bizzabo/design-system';

const useStyles = makeStyles<Theme>(
    theme => ({
        '@global': {
            body: {
                backgroundColor: theme.customization.background.C10,
                color: theme.palette.greys[700],
            },
        },
        layout: {
            color: theme.palette.greys[700],
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'stretch',
            minHeight: '-webkit-fill-available',
            maxHeight: '-webkit-fill-available',
            '--header-padding-top': '22px',
            '--header-padding-bottom': '10px',
            '--header-border-bottom': '1px',
            '--header-height-mobile': '50px',
            '--footer-height-mobile': '70px',
            '--header-logo-height': '60px',
            '--header-height-computed':
                'calc(var(--header-padding-top) + var(--header-padding-bottom) + var(--header-border-bottom) + var(--header-logo-height))',
        },

        actions: {
            display: 'flex',
            width: '100%',
            marginBottom: 20,
            alignItems: 'center',
            '& > * + *': {
                marginLeft: 16,
            },
            [theme.breakpoints.up('sm')]: {
                width: 'fit-content',
            },
        },

        main: {
            display: 'flex',
            padding: '0 0 0 4.5%',
            gap: '4.5%',
            height: '100%',
            overflow: 'auto',

            '& > main': {
                flex: '1 1',
                height: 'fit-content',
            },

            '& > aside': {
                width: 'fit-content',
                maxWidth: 'inherit',
                minWidth: 'inherit',
                position: 'sticky',
                top: 0,
                zIndex: 1001,

                [theme.breakpoints.up('xl')]: {
                    maxWidth: 500,
                },
            },
            [theme.breakpoints.down('sm')]: {
                gap: () => '2% 0', // those are method because we need to override main class above
                padding: () => '0 5.8%', // those are method because we need to override main class above
            },
        },
        footer: {
            display: 'flex',
            position: 'sticky',
            alignItems: 'center',
            bottom: 0,
            right: 0,
            left: 0,
            height: 62,
            minHeight: 'var(--footer-height-mobile)',
            zIndex: 1001,
            padding: '0 16px',
            justifyContent: 'flex-end',
            background: 'transparent',
        },
    }),
    { classNamePrefix: 'ring-layout' }
);

export default useStyles;
